/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface AudioAdded
 */
export interface AudioAdded {
  /**
   *
   * @type {string}
   * @memberof AudioAdded
   */
  message: AudioAddedMessageEnum;
  /**
   *
   * @type {number}
   * @memberof AudioAdded
   */
  seq_no: number;
}

export const AudioAddedMessageEnum = {
  AudioAdded: 'AudioAdded',
} as const;

export type AudioAddedMessageEnum =
  (typeof AudioAddedMessageEnum)[keyof typeof AudioAddedMessageEnum];
